import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { QuickQuoteLife,ErrQuotesLife,PostQuoteLife } from "../../Redux/actions/NumLife";
import { 
  Button, 
  Form,
  Select,
  message
} from 'antd/lib';
import axiosInLife from "../../Redux/axios/AxiosInLife";
import YearDataLife from "../Number LifePage/YearData";

export default function CoverTilAge({setisModalCover}) {
    const dispatch = useDispatch();
    const LifeNum = useSelector((state) => state?.lifedetail?.lifenum);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
    const [loading, setLoading] = useState(false)

    const filteredAgeData = YearDataLife?.filter(item => {
      const PostAge = parseInt(QuotePost?.Age) + 5;
      const age = parseInt(item.value, 10); 
      return age >= PostAge && age <= 85; 
    });
    const onFinish = (values) => {
        console.log('product values',values)
        const UpdatePlan = {
          ...QuotePost,
          suminsured : values?.suminsured_cover,
        }
        setLoading(true)
        axiosInLife
        .post(`v1/life_insurances/${LifeNum?.insurance_id}/quick_quotes`, UpdatePlan)
          .then((res) => {
            if (res.status === 200) {
              const data = res?.data?.data
            console.log(data)
              // const errData = data?.filter(item => ("status" in item && item.status === "failed"));
              // dispatch(ErrQuotesLife(errData));
              const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
              const updatedData = filteredData?.map(item => ({
                ...item,
                selected: false
              }));
              console.log(updatedData)
              dispatch(QuickQuoteLife(updatedData));
              dispatch(PostQuoteLife(UpdatePlan))
              setLoading(false)
              setisModalCover(false)
            }
          })
          .catch((err) => {
            console.log(err.response.data.error);
            setLoading(false)
            message.error(err.response.data.error);
          });
      }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
             <Form.Item
              name="coverAge"
            //   label="Annual Income"
              rules={[
                {
                  required: true,
                  message: "please select Income",
                },
              ]}
            //   initialValue={CusDeatail?.Income}
            >
              <Select
                className="life-age-select"
                style={{ textAlign: "left" }}
                placeholder="Cover Till"
                options={filteredAgeData?.map((p) => ({
                  value: p?.value,
                  label: p?.label,
                }))}
              />
            </Form.Item>
            <Form.Item style={{textAlign: "right"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}
